<template>
    <div class="card">
      <slot />
    </div>
</template>

<script>



export default {
  name: 's-card',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
